module.exports = __webpack_public_path__ + "static/media/olake-section-background.1ab1a1ad.svg";